import { useNavigate } from 'react-router-dom';

/**
 * Update parent iframe hash for navigation tracking
 * @param {string} appName - Name of the app (e.g., 'reports', 'agent-management', 'host-groups')
 * @param {string} route - Current route within the app (default: '/')
 * @param {string} section - Section prefix for hash (default: 'admin', can be '' for root apps)
 */
export function updateParentHash(appName, route = '/', section = 'admin') {
  if (process.env.NODE_ENV === 'development') return;

  const routePath = route === '/' ? '' : route;
  const sectionPath = section ? `/${section}` : '';
  const hash = `#csm2${sectionPath}/${appName}${routePath}`;

  try {
    if (window.parent && window.parent.location.hash !== hash) {
      // Use replaceState to update hash without adding to history
      // This prevents the "double back button" issue
      const currentUrl = window.parent.location.href.split('#')[0];
      window.parent.history.replaceState(null, '', currentUrl + hash);
    }
  } catch {
    // Cross-origin access might be blocked
  }
}

export function useTabNavigation(appName) {
  const navigate = useNavigate();

  const handleTabChange = (tabId) => {
    const route = tabId === 'list' ? '/' : `/${tabId}`;
    navigate(route);
    updateParentHash(appName, route);
  };

  return handleTabChange;
}

